module.exports = __webpack_public_path__ + "img/user2.b59ad8c4.svg";